var map = {
	"./skull_1.png": "b836",
	"./skull_10.png": "eeaf",
	"./skull_10_bj.png": "f984",
	"./skull_11.png": "3509",
	"./skull_11_bj.png": "d706",
	"./skull_12.png": "74bb",
	"./skull_12_bj.png": "6651",
	"./skull_1_bj.png": "5e69",
	"./skull_2.png": "fb01",
	"./skull_2_bj.png": "15dc",
	"./skull_3.png": "a899",
	"./skull_3_bj.png": "bf6b",
	"./skull_4.png": "24c8",
	"./skull_4_bj.png": "6940",
	"./skull_5.png": "1c04",
	"./skull_5_bj.png": "c300",
	"./skull_6.png": "213a",
	"./skull_6_bj.png": "3e92",
	"./skull_7.png": "e361",
	"./skull_7_bj.png": "3287",
	"./skull_8.png": "7b5f",
	"./skull_8_bj.png": "d04a",
	"./skull_9.png": "0b56",
	"./skull_9_bj.png": "0dc5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "20bf";